export default "__VITE_ASSET__1206c2e9__"